// ----------------------------------------------------------------------
// <copyright file="Izenda.CustomDropdown.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Drop Down List component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var observable = require('mobx').observable;
  var action = require('mobx').action;
  var classnames = require('classnames');

  var UiState = require('logic/Izenda.UiState');
  var UIContants = require('logic/data/Izenda.UIConstants');
  var FloatAffixed = require('./Izenda.FloatAffixed');
  var ScrollBox = require('./Izenda.ScrollBox');
  var DEFAULT_IMAGE_MIN_WIDTH = 230;
  const { isNil, find } = require('lodash/fp');

  var ImageHover = observer(function(props) {
    var imageState = props.imageState;
    return imageState.classSprite && imageState.isHover && !UiState.isMobile ? (
      <FloatAffixed
        anchor={imageState.anchor}
        edges="left"
        autoWidth
        minWidth={DEFAULT_IMAGE_MIN_WIDTH}
        className="izenda-DropdownImageSprite"
      >
        <div className="image-hover">
          <div className="image-logo">
            <div className={imageState.classSprite} />
          </div>
        </div>
      </FloatAffixed>
    ) : null;
  });

  var CustomDropdown = React.createClass({
    propTypes: {
      id: React.PropTypes.string,
      options: React.PropTypes.object.isRequired,
      value: React.PropTypes.string,
      valueField: React.PropTypes.string,
      labelField: React.PropTypes.string,
      onChange: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        value: null,
        valueField: 'value',
        labelField: 'label',
        onChange: null
      };
    },

    getInitialState: function() {
      var props = this.props;

      this.imageState = observable({
        isHover: false,
        anchor: null,
        classSprite: ''
      });

      return {
        isOpen: false,
        selected: props.value === null && props.options.length !== 0 ? props.options[0][props.valueField] : props.value
      };
    },

    handleChange: function(option) {
      this.hideListOptions();
      this.props.onChange && this.props.onChange({ value: option.value });
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        selected:
          isNil(nextProps.value) && nextProps.options.length
            ? nextProps.options[0][nextProps.valueField]
            : nextProps.value
      });
    },

    showListOptions: function(event) {
      this.setState({ isOpen: !this.state.isOpen });
    },

    hideListOptions: function(event) {
      this.hideImageSprite();
      this.setState({ isOpen: false });
    },

    showImageSprite: action(function(event) {
      var dataset = event.target.dataset;
      this.imageState.isHover = true;
      this.imageState.anchor = this.refs['customDropdown' + dataset.index];
      this.imageState.classSprite = dataset.sprite;
    }),

    hideImageSprite: action(function() {
      this.imageState.isHover = false;
    }),

    renderListOptions: function() {
      var props = this.props;

      return props.options.map(
        function(option, index) {
          var key = option[props.valueField];
          var label = option[props.labelField];
          var classSprite = option.className && classnames('sprite', option.className);
          var itemClasses = classnames({
            'izenda-CustomDropdown-item': true,
            active: key === props.selected
          });

          return (
            <li
              ref={'customDropdown' + index}
              key={key}
              value={key}
              onClick={this.handleChange.bind(this, option)}
              className={itemClasses}
              data-sprite={classSprite}
              data-index={index}
              onMouseMove={this.showImageSprite}
              onMouseLeave={this.hideImageSprite}
            >
              {label}
            </li>
          );
        }.bind(this)
      );
    },

    render: function() {
      var props = this.props;
      var state = this.state;
      var selectedItem = find({ value: state.selected }, props.options);

      return (
        <div className="dropdown izenda-CustomDropdown">
          <div
            ref="customDropdown"
            className="btn btn-default izenda-CustomDropdown-control"
            onClick={this.showListOptions}
          >
            <span className="select-value">{selectedItem.label}</span>
            <span className="select-arrow" />
          </div>
          {state.isOpen && (
            <FloatAffixed
              className="izenda-CustomDropdown-content"
              edges="under,over"
              anchor={this.refs.customDropdown}
              onClickOutside={this.hideListOptions}
            >
              <ScrollBox autoHeight autoHeightMax={UIContants.dropdownMaxHeight}>
                <ul className="izenda-CustomDropdown-list">{this.renderListOptions()}</ul>
              </ScrollBox>
              <ImageHover imageState={this.imageState} />
            </FloatAffixed>
          )}
        </div>
      );
    }
  });

  module.exports = CustomDropdown;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.CustomDropdown.jsx